import { getToken } from '@/lib/authToken';
/**
 * Lightweight fetch wrapper used across school panels that extracted out of SchoolDetailPage.
 * Prepends `/api/school` and injects the admin bearer token automatically.
 */
const API_URL = process.env.REACT_APP_BACKEND_URL;
export const schoolApi = async (path, opts = {}) => {
  const res = await fetch(`${API_URL}/api/school${path}`, {
    ...opts,
    headers: {
      'Authorization': `Bearer ${getToken()}`,
      'Content-Type': 'application/json',
      ...(opts.headers || {}),
    },
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || 'Request failed');
  }
  return res.json();
};

export default schoolApi;
